"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = void 0;
var tslib_1 = require("tslib");
var ui_butticon_1 = require("@hopin-team/ui-butticon");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.CloseButton = (0, styled_components_1.default)(ui_butticon_1.Butticon)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-left: 0.375rem;\n"], ["\n  margin-left: 0.375rem;\n"])));
var templateObject_1;
//# sourceMappingURL=close-button.js.map